import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getAccount, updateAccount } from '../api/account'
import type { User, AccountSettings } from '../types'

export const ACCOUNT_KEY = ['account'] as const

export function useAccount({ fresh = false }: { fresh?: boolean } = {}) {
  return useQuery<User | null>({
    queryKey: ACCOUNT_KEY,
    queryFn: getAccount,
    staleTime: fresh ? 0 : 5 * 60 * 1000,
    retry: false,
  })
}

export function useUpdateAccount() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (settings: Partial<AccountSettings>) => updateAccount(settings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACCOUNT_KEY })
    },
  })
}
